import React from 'react';
import { BiSolidReport } from 'react-icons/bi';
import { BsBank2 } from 'react-icons/bs';
import { FaHandshake } from 'react-icons/fa';

const WhyTrustUs = () => {
  const features = [
    {
      icon: <FaHandshake className="size-12 text-[#2a9c8e]" />,
      title: 'We’re with you every step of the way',
      description:
        'Manage your retrofit with ease using EPC Builder. Our online tool guides you through the process in five simple steps, and our team is always here to support you.',
    },
    {
      icon: <BsBank2 className="size-12 text-[#2a9c8e]" />,
      title: 'Direct access to grants',
      description:
        "Finding grants can be overwhelming - we make it easy. With over a decade of experience, we unlock exclusive regional funding, often covering costs entirely. If you're ineligible, flexible finance options are available.",
    },
    {
      icon: <BiSolidReport className="size-12 text-[#2a9c8e]" />,
      title: 'Independent, expert advice',
      description:
        'Retrofitting homes since 2011, we provide unbiased recommendations tailored to your property. Unlike automated reports, our experts visit your home to deliver personalised solutions.',
    },
  ];

  return (
    <div className="relative overflow-hidden bg-[#2a9c8e14] px-4 py-8 lg:py-16">
      <div className="z-0 hidden w-full md:absolute md:bottom-0 md:left-0 md:block">
        <img src="/images/houses.svg" alt="House" className="h-auto w-full object-cover object-bottom" />
      </div>
      <div className="relative z-10 flex justify-center">
        <div className="w-full max-w-[1128px]">
          <div className="hidden grid-cols-2 gap-6 md:grid lg:hidden">
            <div className="flex flex-col justify-between gap-6">
              <div>
                <h2 className="text-2xl font-bold lg:text-[32px]">Why homeowners trust us?</h2>
                <p className="mt-2 font-normal leading-[30px] lg:mt-4">
                  Seamless retrofitting from start to finish - with expert support, exclusive funding access, and
                  unbiased recommendations tailored to your home.
                </p>
              </div>
              <div className="flex h-[252px] flex-col rounded-[20px] bg-[#FAFAFA] p-4 lg:p-6">
                <div className="flex items-center gap-4">
                  <div className="shrink-0">{features[2].icon}</div>
                  <h3 className="font-semibold text-[#264653]">{features[2].title}</h3>
                </div>
                <p className="mt-2 text-[16px] leading-[30px] text-[#264653]">{features[2].description}</p>
              </div>
            </div>
            <div className="flex flex-col gap-6">
              {[0, 1].map((index) => (
                <div key={index} className="h-[252px] rounded-[20px] bg-[#FAFAFA] p-4 lg:p-6">
                  <div className="flex items-center gap-4">
                    <div className="shrink-0">{features[index].icon}</div>
                    <h3 className="font-semibold text-[#264653]">{features[index].title}</h3>
                  </div>
                  <p className="mt-2 text-[16px] leading-[30px] text-[#264653]">{features[index].description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="flex flex-col items-start gap-10 md:hidden lg:flex lg:flex-row lg:gap-[64px]">
            <div className="w-full flex-1 lg:max-w-[416px]">
              <h2 className="text-2xl font-bold lg:text-[32px]">Why homeowners trust us?</h2>
              <p className="mt-2 font-normal leading-[30px] lg:mt-4">
                Seamless retrofitting from start to finish - with expert support, exclusive funding access, and unbiased
                recommendations tailored to your home.
              </p>
            </div>
            <div className="flex w-full flex-1 flex-col gap-6">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex w-full flex-col items-start rounded-[20px] bg-[#FAFAFA] p-4 lg:items-start lg:justify-center lg:p-6"
                >
                  <div className="flex flex-row items-center gap-4">
                    <div className="shrink-0">{feature.icon}</div>
                    <h3 className="font-semibold">{feature.title}</h3>
                  </div>
                  <p className="mt-1 font-normal leading-[28px] text-[#516B75] lg:leading-[30px]">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyTrustUs;
